// Spanish translations
export const es = {
  // App
  appName: 'CarTrip',
  signIn: 'Iniciar Sesión',
  signUp: 'Registrarse',
  signOut: 'Cerrar Sesión',
  email: 'Correo Electrónico',
  password: 'Contraseña',
  fullName: 'Nombre Completo',
  
  // Navigation
  home: 'Inicio',
  profile: 'Perfil',
  settings: 'Configuración',
  menu: 'Menú',
  analytics: 'Analítica',
  
  // Trips
  myTrips: 'Mis Viajes',
  newTrip: 'Nuevo Viaje',
  selectTrip: 'Seleccionar Viaje',
  tripName: 'Nombre del Viaje',
  createTrip: 'Crear Viaje',
  deleteTrip: 'Eliminar Viaje',
  stops: 'paradas',
  tripHistory: 'Historial de Viajes',
  
  // Stops
  addStop: 'Añadir Parada',
  editStop: 'Editar Parada',
  deleteStop: 'Eliminar Parada',
  noStops: 'Sin paradas',
  
  // Stop types
  city: 'Ciudad',
  gasStation: 'Gasolinera',
  evCharging: 'Carga EV',
  restaurant: 'Restaurante',
  hotel: 'Hotel',
  attraction: 'Atracción',
  parking: 'Aparcamiento',
  other: 'Otro',
  
  // Common
  cancel: 'Cancelar',
  delete: 'Eliminar',
  close: 'Cerrar',
  save: 'Guardar',
  search: 'Buscar',
  loading: 'Cargando...',
}
